import { openBlock as n, createElementBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return n(), t("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M3 5h18v14H3z"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
